import { BaseModel, type RelationConfig } from './base';

import type { TerminologyTermValue } from '../types/interfaces/terminology';

export class TerminologyTerm extends BaseModel implements TerminologyTermValue {
  singular!: string;
  plural!: string;
  default!: TerminologyTermValue;
  custom!: boolean;
  example!: string;
}

export class Terminology extends BaseModel {
  terms!: Record<string, TerminologyTerm>;

  static override relations(): RelationConfig {
    return {
      terms: {
        transform: (value: Record<string, any>) => {
          const terms: Record<string, TerminologyTerm> = {};

          for (const [key, term] of Object.entries(value || {})) {
            terms[key] = new TerminologyTerm(term as Record<string, any>);
          }

          return terms;
        },
      },
    };
  }
}
